import moment from 'moment';
import { LANGUAGE_CN } from '@intelligence/_config/config';
import { valueFormat, isEmpty } from '@/pages/intelligence/utils/commonUtils';
import {
  SENSOR_TOWER_TAG_KEYS,
  SENSOR_TOWER_TAG_THEME,
  SENSOR_TOWER_TAG_MAP,
  APPMAGIC_TAG_KEYS,
  APPMAGIC_TAG_MAP,
} from '@intelligence/components/Filter/FilterBase/_config';
import {
  PC_CONSOLE_COMBINE_ENTITY_TYPE,
  PC_CONSOLE_COMBINE_MODULE_NAME,
} from '@intelligence/pages/TopCharts/_config/topChartsConst';
import { has, cloneDeep, isFunction } from 'lodash-es';
import { PC_PLATFORMS, CONSOLE_PLATFORMS } from '@intelligence/_config/storeRank/config';
import { isValidDate } from '@intelligence/utils/filterUtils';
import { componentDefault } from '@intelligence/components/Filter/FilterBase/FilterList';
import { toDateTypeFilter } from '@/pages/intelligence/utils/common';
import type { ICommonOption } from '@intelligence/types/common';

const PC_CONSOLE_PLATFORMS = ['ps', 'pc', 'mac', ...PC_PLATFORMS, ...CONSOLE_PLATFORMS];

const PC_CONSOLE_MOBILE_PLATFORMS = [
  'ps',
  'pc',
  'android',
  'ios',
  ...PC_PLATFORMS,
  ...CONSOLE_PLATFORMS,
];

// 用于多级value的连接，把多级value通过@字符连接为一个字符串
export const COMMON_JOINER = '@';

// metric_list按数据源与指标名称重新排序
export const sortByTargetMetricList = (metricsList: any[], sourceList: any[], valueList: any[]) => {
  const resultList = [];
  for (const n in metricsList) {
    // let metricArr = [];
    for (const m in sourceList) {
      for (const x in valueList) {
        if (valueList[x].metric == metricsList[n] && valueList[x].source == sourceList[m]) {
          resultList.push(valueList[x]);
        }
      }
      // resultList.push(sourceArr);
    }
  }
  return resultList;
};

// metric_list按数据源与指标名称重新排序
export const sortBySourceMetricList = (
  sourceList: any[],
  metricsList: any[],
  sourceMap = {} as any,
) => {
  const resultList = [];
  for (const m in sourceList) {
    for (const x in metricsList) {
      if (sourceMap[metricsList[x].data_source] == sourceList[m]) {
        resultList.push(metricsList[x]);
      }
    }
  }
  return resultList;
};

export const getEntityType = (str: string) => {
  switch (str) {
    case 'mobileGames':
      return 'mobile';
    case 'pcGames':
      return 'pc';
    case 'consoleGames':
      return 'console';
    case 'companies':
      return 'company';
    default:
      return 'mobile';
  }
};

export const entityTypeMsg = {
  mobile: {
    icon: 'other-icon',
    // name: 'Mobile',
    name: 'dbi_mobile',
    path: 'mobileGames',
  },
  pc: {
    icon: 'monitor',
    // name: 'PC',
    name: 'dbi_pc',
    path: 'pcGames',
  },
  console: {
    icon: 'game',
    // name: 'Console',
    name: 'dbi_console',
    path: 'consoleGames',
  },
  combine: {
    icon: 'pc-console-combine',
    name: 'dbi_pc_console_combine',
    path: 'pcConsoleGames',
  },
} as any;

// export const getModuleName = (str: string) => {
//   switch (str) {
//     case 'mobile':
//       return 'mobileGames';
//     case 'pc':
//       return 'pcGames';
//     case 'console':
//       return 'consoleGames';
//     case 'company':
//       return 'companies';
//     default:
//       return 'mobileGames';
//   }
// }

// 分大洲国家数据转换为纯国家数据
export function getZhouToCountryList(ary: any[]) {
  if (!ary?.length) {
    return null;
  }
  const arrtemp = ary || [];
  const arr = [];
  for (const n in arrtemp) {
    arr.push(...(arrtemp[n].country_set ? arrtemp[n].country_set : []));
  }
  // console.log('arrarrarr', arr);
  return arr;
}

// 在详情页Stats获取页签
// export function getStatsParamFromUrl(str = '') {
//   const [_v, system, _system, mainMenu, subMenu, gameId, tab, childTab] = str.trim().split('/')
//   return {
//     mainMenu,
//     subMenu,
//     gameId,
//     tab,
//     childTab
//   }
// }

type ComputyType = {
  sum: number;
  avg: number;
  max: number;
};

export function getComputeType(data: string | ComputyType) {
  const type = typeof data === 'string' ? data : '';
  const obj: ComputyType =
    typeof data === 'object'
      ? data
      : {
          sum: 0,
          avg: 0,
          max: 0,
        };
  if (type === 'sum' || obj?.sum > 0) {
    return 'Sum';
  }
  if (type === 'avg' || obj?.avg > 0) {
    return 'Avg';
  }
  if (type === 'max' || obj?.max > 0) {
    return 'Max';
  }
  return type;
}

// 根据折线图类型，获取对应num，解决异步数据问题
// export function getNumFromChartType(data: string) {
//   switch (data) {
//     case 'bar':
//       return 0;
//     case 'line':
//       return 1;
//     case 'pie':
//       return 2;
//     default:
//       return 0;
//   }
// }

//   根据后端接口返回的数据获取计算聚合方式,返回聚合类型，传入参数avg,sum值，max值
export function getComputeTypeStreaming(avgValue = 0, sumValue = 0, maxValue = 0) {
  const _typeArr = ['Avg', 'Sum', 'Max'];
  const _arr = [avgValue, sumValue, maxValue];
  let _type = '';
  let _value: any = '';
  for (let i = 0; i < 3; i++) {
    if (_arr[i] != 0) {
      _type = _typeArr[i];
      // 和表格一样小于1K取整
      _value = valueFormat(_arr[i], false, 0);
    }
  }
  return {
    type: _type,
    value: _value,
  };
}

/**
 * 从指定video视频 截取指定时间点的帧，不支持m3u8
 * @param {string} url video资源url
 * @param {number} startTime 截图时间点 单位为秒
 * @returns base64图片
 */
export const getImageBase64fromVideoSource = (url: any, startTime = 0) =>
  new Promise((resolve) => {
    const videoEl = document.createElement('video');
    videoEl.setAttribute('crossorigin', 'anonymous');
    videoEl.setAttribute('src', url);
    videoEl.setAttribute('width', '400');
    videoEl.setAttribute('height', '240');
    videoEl.currentTime = startTime;
    videoEl.addEventListener('loadeddata', () => {
      const cvs = document.createElement('canvas');
      const ctx = cvs.getContext('2d');
      const { width } = videoEl;
      const { height } = videoEl;
      let src = '';
      cvs.width = width;
      cvs.height = height;
      cvs.setAttribute('crossorigin', 'anonymous');
      ctx?.drawImage(videoEl, 0, 0, width, height);
      src = cvs.toDataURL('image/jpeg');
      resolve(src);
    });
    videoEl.addEventListener('error', (e) => {
      console.error('截图异常 error: ', e);
      resolve('');
    });
    videoEl.addEventListener('abort', (e) => {
      console.error('截图异常 abort: ', e);
      resolve('');
    });
    videoEl.addEventListener('emptied', (e) => {
      console.error('截图异常 emptied: ', e);
      resolve('');
    });
    videoEl.addEventListener('stalled', (e) => {
      console.error('截图异常 stalled: ', e);
      resolve('');
    });
  });

// youtube站点
const YOUTUBE_SOURCE = 'www.youtube.com';
// pv游戏介绍视频，需要通过iframe嵌入视频资源的域名
const IFRAME_VIDEO_SOURCES = [YOUTUBE_SOURCE];

/**
 * 判断指定资源链接是否通过iframe嵌入，用于游戏PV视频介绍
 * @param url 资源链接
 * @returns 是否通过iframe形式嵌入资源
 */
export const isIframeSource = (url: string): boolean =>
  IFRAME_VIDEO_SOURCES.some((item) => new RegExp(`^((http|https)://)?${item}`).test(url));

export const getVideosCommon = (videoSourcesStr: string): any => {
  if (typeof videoSourcesStr !== 'string') return [];
  return videoSourcesStr
    .split('|')
    .map((url) => {
      const newUrl = url;
      // youtube视频资源 由于爬虫端 爬取的是 视频播放页面的url，不是视频资源url，所以要做下面的url replace处理
      // if (isYoutube(url)) {
      //   const { v: videoId } = getURLSearchParams(url) || {};
      //   const videoSourcePath = `embed/${videoId}`;
      //   const idx = newUrl.lastIndexOf('/');
      //   newUrl = `${newUrl.substring(0, idx)}/${videoSourcePath}`;
      // }
      return {
        url: newUrl,
        poster: '',
        isIframe: isIframeSource(url) || false,
      };
    })
    .filter((item) => item.url);
};

export const updateVideosPosterCommon = async (
  videos: any[],
  setter: Function,
  startTime = 10,
): Promise<void> => {
  if (!Array.isArray(videos)) return;
  let newVideos = [...videos];
  for (let i = 0; i < videos.length; i++) {
    const video = videos[i];
    // iframe(主要是youtube来源的视频)、m3u8格式视频  不能截图
    const poster =
      video.isIframe || video.url?.endsWith('.m3u8')
        ? ''
        : await getImageBase64fromVideoSource(video.url, startTime);
    const newVideo = {
      ...video,
      poster,
    };
    newVideos = [...newVideos.slice(0, i), newVideo, ...newVideos.slice(i + 1)];
    setter(newVideos);
  }
};

export const mergeCardRankData = (srcList: any, rankData: any) => {
  if (!Array.isArray(srcList) || !Array.isArray(rankData)) {
    return srcList;
  }
  const newList = srcList;
  const metrics = rankData.map((item) => item?.metric);
  srcList.forEach((item, i) => {
    const _metric = item?.metric;
    const idx = metrics.indexOf(_metric);
    /** PHeat不用合 */
    if (_metric !== 'PHeat' && idx !== -1) {
      /** 将Rank数据填到卡片数据中 */
      newList[i].rank = rankData[idx].rank;
      newList[i].value_dod = rankData[idx].value_dod;
    }
  });
  return newList;
};

export const transEditionParams = (data: any) => {
  /* start_date指标的时间可以从summary的卡片的列表中的end_date来取
   *end_date=start_date
   *is_ogdb 指标的数据来源从summary的卡片列表来取，如果是ogdb的话，则is_ogdb为1
   */
  if (!Array.isArray(data)) {
    return [];
  }
  const editionDateMap: any[] = [];
  data?.forEach((item) => {
    const _editionDateItem = {
      metric_name: item?.metric,
      last_date: item?.end_date,
      cur_date: item?.start_date,
      is_ogdb: item?.data_source === 'ogdb' ? '1' : '0',
    };
    editionDateMap.push(_editionDateItem);
  });
  return editionDateMap;
};

export const getLastMonthWeekDay = (dateVal: string, dateType: string) => {
  if (moment(dateVal).format('YYYY-MM-DD') === 'Invalid date') {
    return '';
  }
  // 上个月，上一周， 前一天
  switch (dateType) {
    case 'month':
    case 'monthly':
      return moment(dateVal).subtract(1, 'months').format('YYYY-MM-DD');
    case 'week':
    case 'weekly':
      return moment(dateVal).subtract(1, 'weeks').format('YYYY-MM-DD');
    case 'day':
    case 'daily':
      return moment(dateVal).subtract(1, 'days').format('YYYY-MM-DD');
    default:
      return '';
  }
};

// 游戏详情卡片overview，dau指标mau/wau/dau，暂时强转为dau传参
const getReturnDau = (metric: string) => {
  if (metric === 'mau' || metric === 'wau') {
    return 'dau';
  }
  return metric;
};

export const transRankParams = (data: any, dateType: string, isEdition = false) => {
  if (!Array.isArray(data)) {
    return [];
  }
  const rankDateMap: any[] = [];
  data?.forEach((item) => {
    const _lastDate = getLastMonthWeekDay(item?.date, dateType);
    const _rankDateItem = {
      metric_name: isEdition ? getReturnDau(item?.metric) : item?.metric,
      cur_date: item?.date,
      last_date: _lastDate,
      is_ogdb: item?.data_source === 'ogdb' ? '1' : '0',
      data_source: item.data_source,
    };
    rankDateMap.push(_rankDateItem);
  });
  return rankDateMap;
};

export const changeTimetoDay = (time: string) => {
  const _time = typeof time === 'string' ? time.toLocaleLowerCase() : '';
  switch (_time) {
    case 'day':
    case 'daily':
      return 'day';
    case 'week':
    case 'weekly':
      return 'week';
    case 'month':
    case 'monthly':
      return 'month';
    default:
      return 'day';
  }
};

// 首字母大写
export const toUpperFirstCase = (str: string) => {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.slice(0, 1).toLocaleUpperCase() + str.slice(1).toLocaleLowerCase();
};

export const getDefaultTime = (timeType: string, isTwoMonRelease = false) => {
  const timeTypeLower = typeof timeType === 'string' ? timeType.toLocaleLowerCase() : '';
  const type = changeTimetoDay(timeTypeLower) || 'day';
  if (type === 'day') {
    // 如果是新游，返回默认近7天，否则返回近30天
    if (isTwoMonRelease) {
      return [moment().subtract(7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
    }
    return [moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
  }
  if (type === 'week') {
    // 周日开始周六结束 ，6周
    return [
      moment().subtract(7, 'week').weekday(7).format('YYYY-MM-DD'),
      moment().subtract(1, 'week').weekday(6).format('YYYY-MM-DD'),
    ];
  }
  if (type === 'month') {
    return [
      `${moment().subtract(5, 'month').format('YYYY-MM')}-01`,
      `${moment().format('YYYY-MM')}-01`,
    ];
  }
  return [];
};

export const tranksPlatformName = (key: string) => {
  switch (key) {
    case 'facebook':
      return 'Facebook';
    case 'twitch':
      return 'Twitch';
    case 'ytg':
      return 'Youtube';
    default:
      return;
  }
};

const getDetailGamePathCommonSearchParams = (query?: IRecord): string => {
  if (!query) {
    return '';
  }

  const searchParams = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (!!value) {
      searchParams.set(key, encodeURIComponent(value));
    }
  });

  return searchParams.toString();
};

/** 只获取URL地址，不作跳转操作 */
export const getDetailGamePathCommon = (params: {
  entityType: string;
  gameId: string;
  tab: string;
  subTab?: string;
  query?: IRecord;
}) => {
  const { entityType, gameId, tab, subTab, query } = params;

  if (!gameId) return '';

  const searchParams = getDetailGamePathCommonSearchParams(query);
  let url = '';

  const modelName = (() => {
    if (entityType === 'pc') return 'pcGames';
    if (entityType === 'console') return 'consoleGames';
    if (entityType === 'company') return 'companies';
    if (entityType === PC_CONSOLE_COMBINE_ENTITY_TYPE) return PC_CONSOLE_COMBINE_MODULE_NAME;
    return 'mobileGames';
  })();

  if (tab === 'storeRank') {
    url = `/intelligence/topCharts/${modelName}/gamesDetails/${gameId}/${tab}${
      subTab ? `?source=${subTab}` : ''
    }`;
  } else {
    url = `/intelligence/topCharts/${modelName}/gamesDetails/${gameId}/${tab}${
      subTab ? `/${subTab}` : ''
    }`;
  }

  if (!!searchParams) {
    return url.includes('?') ? `${url}&${searchParams}` : `${url}?${searchParams}`;
  }

  return url;
};

export const getDetailGameOverviewPath = (gameId: string, entityType: string) =>
  getDetailGamePathCommon({
    entityType,
    gameId,
    tab: entityType === 'company' ? 'Summary' : 'overview',
  });

const getSegmentsPath = (...segments: (string | undefined)[]): string => {
  if (!Array.isArray(segments)) return '';
  let path = '';
  for (const segment of segments) {
    if (!segment) break;
    path += `_${segment}`;
  }
  return path.substring(1);
};
// 获取公司详情页path
export const getCompanyDetailsPath = (params: {
  companyId: string;
  tab?: string;
  segment?: string;
  subSegment?: string;
  dataSources?: string;
}) => {
  const { companyId, tab: tabOuter, segment, subSegment, dataSources } = params ?? {};
  if (!companyId) return '';
  const tab = tabOuter ?? 'Summary';
  const basePath = `/intelligence/topCharts/companies/gamesDetails/${companyId}/${tab}`;
  const segmentsPath = getSegmentsPath(segment, subSegment);
  const lastPath = segmentsPath ? `${basePath}/${segmentsPath}` : basePath;
  return `${lastPath}?dataSources=${dataSources}`;
};

/**
 * 获取entityType对应的图片尺寸信息，包含width、height
 * 目前只有mobile的图片尺寸信息是正确的，其他需要有使用的场景时，更新为正确的尺寸
 * @param type entityType，目前包含mobile、pc、console、company
 * @returns entityType对应的图片尺寸信息
 */
export const getEntityImageSizeInfo = (type: string): { width: string; height: string } => {
  switch (type) {
    case 'pc':
      return { width: '40px', height: '40px' };
    // return '68.6px'
    case 'console':
      return { width: '40px', height: '40px' };
    // return '25.6px'
    case 'company':
      return { width: '40px', height: '40px' };
    // return '32px'
    case 'mobile':
    default:
      return { width: '40px', height: '40px' };
  }
};

const DATASOURCE_METRIC_KEY_JOINER = '###';
export const generateDataSourceMetricKey = (
  dataSource: string,
  metric: string,
  joiner = DATASOURCE_METRIC_KEY_JOINER,
): string => {
  if (!dataSource) return '';
  if (!metric) return '';
  return `${dataSource}${joiner}${metric}`;
};
export const analysisDataSourceMetricKey = (
  dataSourceMetricKey: string,
  joiner = DATASOURCE_METRIC_KEY_JOINER,
): {
  dataSource: string;
  metric: string;
} => {
  if (typeof dataSourceMetricKey !== 'string')
    return {
      dataSource: '',
      metric: '',
    };

  const [dataSource, metric] = dataSourceMetricKey.split(joiner);

  return {
    dataSource: dataSource || '',
    metric: metric || '',
  };
};

export const analysisPlatformsByString = (str?: string): string[] => {
  if (typeof str !== 'string') return [];
  const lowerStr = str.toLowerCase();
  return PC_CONSOLE_PLATFORMS.filter((platform) => lowerStr.includes(platform));
};

export const analysisPlatformsBasicByString = (str?: string): string[] => {
  if (typeof str !== 'string') return [];
  const lowerStr = str.toLowerCase();
  return PC_CONSOLE_MOBILE_PLATFORMS.filter((platform) => lowerStr.includes(platform));
};

export const getValidTopSelectGame = (value: string, max = 10) => {
  const valueNum = Number(value);
  if (!isNaN(valueNum) && valueNum > 0 && valueNum <= max) {
    return valueNum;
  }
};

export const getTopMobilesCustomValidUrlParams_Nikke = (history: any) => {
  const { query } = history.location || {};
  const orderMetric = ['dau', 'revenue', 'download', 'arpu']?.includes(query?.orderMetric)
    ? query?.orderMetric
    : 'dau';
  const pageSizeNum = Number(query?.pageSize);
  const pageSize = !isNaN(pageSizeNum) && pageSizeNum <= 50 && pageSizeNum > 0 ? pageSizeNum : 50;
  const order = ['desc', 'asc'].includes(query?.order) ? query?.order : 'desc';
  // 请做错误判断处理
  const nikkeParams = {
    page_size: pageSize,
    order,
    order_metric: orderMetric,
  };
  return nikkeParams;
};

/**
 * 获取option选项名称
 * @param locale 语言
 * @param option option选项
 * @returns option选项名称
 */
export const getOptionText = (locale: string, option: ICommonOption): string => {
  if (!option) return '';
  // 兜底名称
  const text = option?.textEN || option?.textCN || option?.text || option?.value || '';
  return (locale === LANGUAGE_CN ? option?.textCN : option?.textEN) || text;
};

export const tranFormSenorTowerTagParam = (param: { [key: string]: any }) => {
  if (!param) return param;
  const newParams = cloneDeep(param);
  const sensor_tower_tags: any[] = [];
  // 目前这个函数有的地方不需要了，所以不能全部都走下面的处理，用needUpdate来判断
  let needUpdate = false;
  for (let i = 0; i < SENSOR_TOWER_TAG_KEYS?.length; i++) {
    if (has(newParams, SENSOR_TOWER_TAG_KEYS[i])) {
      needUpdate = true;
      if (SENSOR_TOWER_TAG_KEYS[i] === SENSOR_TOWER_TAG_THEME) {
        const list = newParams[SENSOR_TOWER_TAG_KEYS[i]]?.map((item) =>
          analysisDataSourceMetricKey(item, COMMON_JOINER),
        );
        const tagList = list?.reduce((result, item) => {
          const index = result?.findIndex((config) => config?.tag_name === item?.dataSource);
          if (index > -1) {
            result[index].Tags.push({ tag_name: item?.metric });
          } else {
            result.push({
              tag_name: item?.dataSource,
              Tags: [{ tag_name: item?.metric }],
            });
          }
          return result;
        }, []);

        sensor_tower_tags.push({
          tag_name: SENSOR_TOWER_TAG_MAP[SENSOR_TOWER_TAG_KEYS[i]] || '',
          Tags: tagList,
        });
      } else {
        sensor_tower_tags.push({
          tag_name: SENSOR_TOWER_TAG_MAP[SENSOR_TOWER_TAG_KEYS[i]] || '',
          Tags: newParams[SENSOR_TOWER_TAG_KEYS[i]]?.map((item) => ({
            tag_name: item,
          })),
        });
      }

      delete newParams[SENSOR_TOWER_TAG_KEYS[i]];
    }
  }
  if (!needUpdate) {
    return param;
  }
  const list = sensor_tower_tags?.filter((item) => item?.Tags?.length);
  newParams.sensortower_tag_filter = list;
  return newParams;
};

export const handleSensorTowerValueFilter = (filterData: any) => {
  try {
    const sensor_tower_tags: any[] = [];
    for (let i = 0; i < SENSOR_TOWER_TAG_KEYS?.length; i++) {
      const sensortowerKey = SENSOR_TOWER_TAG_KEYS[i];
      const sensortowerKeyValue = filterData[sensortowerKey]?.value;
      // if(has(newParams, SENSOR_TOWER_TAG_KEYS[i])){
      if (sensortowerKey === SENSOR_TOWER_TAG_THEME) {
        const list = sensortowerKeyValue?.map((item) =>
          analysisDataSourceMetricKey(item, COMMON_JOINER),
        );
        const tagList = list?.reduce((result, item) => {
          const index = result?.findIndex((config) => config?.tag_name === item?.dataSource);
          if (index > -1) {
            result[index].Tags.push({ tag_name: item?.metric });
          } else {
            result.push({
              tag_name: item?.dataSource,
              Tags: [{ tag_name: item?.metric }],
            });
          }
          return result;
        }, []);

        sensor_tower_tags.push({
          tag_name: SENSOR_TOWER_TAG_MAP[sensortowerKey] || '',
          Tags: tagList,
        });
      } else {
        sensor_tower_tags.push({
          tag_name: SENSOR_TOWER_TAG_MAP[sensortowerKey] || '',
          Tags: sensortowerKeyValue?.map((item) => ({ tag_name: item })),
        });
      }
    }
    const list = sensor_tower_tags?.filter((item) => item?.Tags?.length);
    return { sensortower_tag_filter: list };
  } catch (err) {
    return {};
  }
};

// 处理App Magic Tags筛选器数据转换为接口入参格式
export const handleAppMagicValueFilter = (filterData: any) => {
  try {
    const appMagicTags: IRecord<string[]> = {};

    for (const appmagicKey of APPMAGIC_TAG_KEYS) {
      const apiFieldName = APPMAGIC_TAG_MAP[appmagicKey];
      const appmagicKeyValue = filterData?.[appmagicKey]?.value;
      appMagicTags[apiFieldName] = appmagicKeyValue || [];
    }

    return { app_magic_tags: appMagicTags };
  } catch (err) {
    return { app_magic_tags: {} };
  }
};

/**
 * 获取指定device分类下的细分类device集合（即拆分device大分类为 细分类device集合）
 * @param cascaderDevices device的options集合（级联）
 * @param deviceCategories device的分类（可能值为PC、PlayStation、Xbox、Nintendo这种device的大分类）
 * @returns device的分类 对应的 device细分类集合（可能值为PC、PS4、PS5、Xbox One这种device的细分类）
 */
export const getSeparatedDevicesOfDeviceCategories = (
  cascaderDevices?: ICommonOption[],
  deviceCategories?: string[],
): string[] => {
  if (!Array.isArray(cascaderDevices) || !cascaderDevices.length) return [];
  if (!Array.isArray(deviceCategories) || !deviceCategories.length) return [];
  const deviceCategoriesLowerCase = deviceCategories.map((deviceCategory) =>
    deviceCategory?.toLowerCase(),
  );
  /**
   * 1、过滤掉deviceCategories中不存在的cascaderDevice
   * 2、扁平化处理每一个cascaderDevice的细分类devices
   */
  return cascaderDevices
    .filter((cascaderDevice) =>
      deviceCategoriesLowerCase.includes(cascaderDevice?.value?.toLowerCase()),
    )
    .flatMap((cascaderDevice) => {
      const subDevices = cascaderDevice?.children?.map((subDevices) => subDevices?.value);
      return Array.isArray(subDevices) ? subDevices : [];
    });
};

interface ItemType {
  id: string;
  typeIdList?: { type: string; id: string }[];
  entityType?: string;
}

export function handleAllGameFilter(checkedList: ItemType[]) {
  if (!Array.isArray(checkedList) || !checkedList?.length) {
    return { mobile: [], pc: [], console: [], combine: [] };
  }
  // 获取到类型id分类，并返回对应类型的id
  const typeIdObj = checkedList.reduce(
    (obj: any, item) => {
      if (Array.isArray(item?.typeIdList)) {
        // 将typeldList的值一一分类
        const types = item.typeIdList?.map((t) => t?.type);
        item.typeIdList.forEach((k) => {
          if (obj[k?.type]) {
            if (k?.type === 'combine') {
              // combine时，要存在pc,console的一方才行
              if (types.includes('pc') || types.includes('console')) {
                obj[k.type].push(k.id);
                // 有勾选数据，则把空字符去掉
                if (obj[k.type][0] === '') {
                  obj[k.type].shift();
                }
              }
            } else {
              obj[k.type].push(k.id);
              // 有勾选数据，则把空字符去掉
              if (obj[k.type][0] === '') {
                obj[k.type].shift();
              }
            }
          }
        });
      }
      return obj;
      // 因为checkedList有勾选游戏，所以给每个平台配备一个空串，后端识别为['']时返回无数据，为[]时无勾选则返回列表
    },
    { mobile: [''], pc: [''], console: [''], combine: [''] },
  );

  return typeIdObj;
}

const getGameTypeOpinion = (list: any, typeObj: any, entityType: string) =>
  list?.find((item: any) => item.edition_unified_id == typeObj[entityType]);

export const getIsOpinionFromType = (list: any, combineGameIdList: any, entityType: string) => {
  const typeObj = {
    mobile: '',
    pc: '',
    console: '',
    combine: '',
  } as any;
  combineGameIdList?.forEach((item: any) => (typeObj[item.entity_type] = item.id));
  // 如果是mobile类型，只判断mobile是否有舆情
  if (entityType === 'mobile') {
    return getGameTypeOpinion(list, typeObj, 'mobile');
  }
  if (entityType === 'pc' || entityType === 'combine') {
    // 如果是pc或combine类型，先判断pc是否再判断console是否有舆情
    const pcOpinion = getGameTypeOpinion(list, typeObj, 'pc');
    return pcOpinion?.opinion_data ? pcOpinion : getGameTypeOpinion(list, typeObj, 'console');
  } // 如果是console类型，先判断console是否再判断pc是否有舆情
  const consoleOpinion = getGameTypeOpinion(list, typeObj, 'console');
  return consoleOpinion.opinion_data ? consoleOpinion : getGameTypeOpinion(list, typeObj, 'pc');
};

// 设置跳转经分记录内容
export const setItemDashboardTips = (ifShow: boolean, openTotal = 1) => {
  const today = moment().format('YYYY-MM-DD');
  const newTips = {
    ifShow,
    openDay: today,
    openTotal,
  };
  localStorage.setItem('dbi_dashboard_tips', JSON.stringify(newTips));
};

// 获取跳转经分记录内容
export const getItemDashboardTips = () => {
  const dashboardTipsTemp = localStorage.getItem('dbi_dashboard_tips') || '';
  const dashboardTips = dashboardTipsTemp !== '' ? JSON.parse(dashboardTipsTemp) : {};
  return dashboardTips;
};

// 获取overview卡片指标名称
export const getMetricTitle = (metric: string, moduleName: string): string => {
  if (moduleName === 'companies') {
    return metric?.endsWith('Revenue') ? `${metric}($)` : metric;
  }
  return metric === 'PHeat' ? 'P.Heat' : metric;
};

// 获取Progress卡片指标名称
export const getStrokeColor = (platform: string) => {
  switch (platform) {
    case 'playstation store':
      return '#5ec8f1';
    case 'nintendo eshop':
      return '#f19e55';
    case 'microsoft store':
      return '#5086f3';
    case 'PS':
      return '#5ec8f1';
    case 'Nintendo':
      return '#f19e55';
    case 'Steam':
      return '#5086f3';
    case 'Xbox':
      return '#69d19c';
    case 'Epic':
      return '#f5d242';
    default:
      return '#f17c86';
  }
};

// 判断segment是否需要展示数据源提示
export const getIfShowSourceExplanation = (seg: string) => {
  return ['allMetrics', 'digitalRevenue', 'gsd', 'steamSales', 'physicalRevenue']?.includes(seg);
};

// 根据Platform选择，返回对应的appIds
export const getAppIdsListByPlatform = (appIds: any[], params: any, appIdListAll: any[]) => {
  if (isEmpty(appIdListAll) || isEmpty(params) || !Array.isArray(appIdListAll)) return appIds;

  const platformList = params?.platforms || ['googleplay', 'appstore'];
  const platValue = platformList?.map((item: string) => {
    return item === 'googleplay' ? 'android' : 'ios';
  });
  // 获取对应平台的此游戏下的appIdList
  const appIdListByPlat = appIdListAll
    ?.filter((item: any) => platValue?.includes(item.platform))
    ?.map((item: any) => item.id);
  return appIds?.filter((appId: any) => appIdListByPlat?.includes(appId));
};

/**
 * 检查一个列表数据是否为空数据
 * 1、空列表 判定为 空数据
 * 2、列表不为空，但是列表中每一条数据都没值，也判定为 空数据
 * @param list 列表数据
 * @param valueKey 列表数据中每条数据的值的字段，或者为计算每条数据的方法
 * @return 指定列表是否为空数据
 */
export const checkIsEmptyList = (list?: any[] | null, valueKey?: string | ((payload?: any) => any)): boolean => {
  if (!Array.isArray(list) || !list.length) return true;

  return list.every((item) => {
    const itemValue = isFunction(valueKey) ? valueKey(item) : item?.[valueKey || 'value'];
    if (isEmpty(itemValue)) return true;
    if (typeof itemValue === 'number') return Number.isNaN(itemValue);
    return false;
  });
};

const getSinceReleaseTimeM = (releaseTime?: string): moment.Moment => {
  if (!releaseTime) return moment();

  let m: moment.Moment | null = null;

  if (/^\s*\d{4}\s*$/g.test(releaseTime)) { // 年粒度
    m = moment(releaseTime, 'YYYY').startOf('year');
  } else if (/^\s*(\d{4})-(Q\d)\s*$/gi.test(releaseTime)) { // 季度粒度
    m = moment(releaseTime, 'YYYY-Q').startOf('quarter');
  } else if (/^\s*(\d{4})-(\d{2})\s*$/g.test(releaseTime)) { // 月烈度
    m = moment(releaseTime, 'YYYY-MM').startOf('month');
  } else if (/^\s*(\d{4})-(\d{2})-(\d{2})\s*$/g.test(releaseTime)) { // 日粒度
    m = moment(releaseTime, 'YYYY-MM-DD').startOf('day');
  }

  return m?.isValid() ? m : moment();
};

/**
 * 获取游戏发布时间（给RangeTime组件使用，即配置RangeTime组件的Since Release Time相关的时间）
 * @param releaseTime 游戏的发布时间
 * @return RangeTime组件的发布时间
 */
export const getSinceReleaseTimeOfRangePicker = (releaseTime?: string): string => {
  const releaseTimeM = getSinceReleaseTimeM(releaseTime);
  return releaseTimeM.format('YYYY-MM-DD');
};
